export function normalizeBarcode(raw) {
    return raw.trim().replace(/\s+/g, '');
}
export function barcodeKind(barcode) {
    const value = normalizeBarcode(barcode);
    if (!/^\d+$/.test(value))
        return 'other';
    if (value.length === 13)
        return 'ean13';
    if (value.length === 12)
        return 'upca';
    if (value.length === 8)
        return 'ean8';
    return 'other';
}
/** Digito verificador GTIN (modulo 10) para EAN-8, UPC-A e EAN-13. */
export function gtinCheckDigit(digitsWithoutCheck) {
    let sum = 0;
    const digits = digitsWithoutCheck.split('').reverse();
    for (let i = 0; i < digits.length; i += 1) {
        const digit = Number(digits[i]);
        sum += i % 2 === 0 ? digit * 3 : digit;
    }
    return (10 - (sum % 10)) % 10;
}
/**
 * Valida o digito verificador quando o formato permite. Codigos nao numericos
 * (Code 128, QR) sao aceitos como estao: recusar um scan valido custa mais ao
 * usuario do que aceitar um codigo estranho.
 */
export function isValidBarcode(barcode) {
    const value = normalizeBarcode(barcode);
    if (value.length === 0)
        return false;
    const kind = barcodeKind(value);
    if (kind === 'other')
        return true;
    const body = value.slice(0, -1);
    const check = Number(value.slice(-1));
    return gtinCheckDigit(body) === check;
}
/**
 * Codigo interno para produtos sem codigo de barras (hortifruti, granel).
 * Usa o prefixo 200 (faixa reservada para uso interno), o que permite imprimir
 * a etiqueta como um EAN-13 valido no futuro.
 */
export function generateInternalBarcode(random = Math.random) {
    let body = '200';
    for (let i = 0; i < 9; i += 1) {
        body += Math.floor(random() * 10).toString();
    }
    return body + gtinCheckDigit(body).toString();
}
export function isInternalBarcode(barcode) {
    const value = normalizeBarcode(barcode);
    return value.length === 13 && value.startsWith('200');
}
//# sourceMappingURL=barcode.js.map